// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__auagP","title":"styles_title__PAMYl","skeleton-animation":"styles_skeleton-animation__74jnI"};